import { Checkbox, CheckboxProps, Loader } from '@mantine/core'
import { IconCheck, IconX } from '@tabler/icons-react';

interface CustomCheckboxProps extends CheckboxProps {
  loading?: boolean;
}

const CustomCheckbox = (props: CustomCheckboxProps) => {

  const CheckboxIcon: CheckboxProps['icon'] = ({ indeterminate, ...others }) =>
    props.loading ? <Loader {...others} size={12} /> : props.checked ? <IconCheck {...others} /> : null;

  if (props.readOnly) {
    return props.checked ? <IconCheck size={16} /> : <IconX size={16} />
  }

  return (
    <Checkbox
      color={'#2F6F16'}
      {...props}
      // icon={CheckboxIcon}
      disabled={props.disabled || props.loading}
    />
  )
}

export default CustomCheckbox;